// extracted by mini-css-extract-plugin
module.exports = {"descriptionWrapper":"styles_descriptionWrapper__ClJ5a","iconStyling":"styles_iconStyling__zUQ3B"};